import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "We'd love to learn more about you")
], -1);
const _hoisted_3 = { class: "columns mt-4" };
const _hoisted_4 = { class: "columns mt-4" };
const _hoisted_5 = { class: "columns" };
const _hoisted_6 = { class: "columns" };
const _hoisted_7 = { class: "columns" };
const _hoisted_8 = { class: "columns" };
import { Validations, useValidation } from "@/composables/useValidation";
import { ProfileTypes } from '@minicity/core';
import { notifyError } from "@/core/utils";
import { onMounted, ref } from "vue";
import LocationListField from "./LocationListField.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerOnboardingFormProfilePage',
    props: {
        modelValue: {}
    },
    emits: ['update:modelValue', 'proceed'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { areAllFieldsValid, validator } = useValidation();
        const req = ref(null);
        onMounted(() => {
            req.value = Object.assign({}, props.modelValue);
        });
        const onChanged = () => {
            emit("update:modelValue", req.value);
        };
        const onSubmitClicked = () => {
            if (!areAllFieldsValid.value) {
                notifyError("Please ensure all fields are filled out correctly");
                return;
            }
            if (req.value.siteNames.length == 0) {
                notifyError("Please enter the name of at least one location");
                return;
            }
            emit('proceed');
        };
        return (_ctx, _cache) => {
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_FormSelectField = _resolveComponent("FormSelectField");
            const _component_SaveButton = _resolveComponent("SaveButton");
            return (req.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.displayName,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((req.value.admin.displayName) = $event)),
                            onChange: _cache[1] || (_cache[1] = ($event) => (onChanged())),
                            validator: _unref(validator)(_unref(Validations).notEmpty),
                            label: "Preferred Name *",
                            description: "Please enter your full name, as you would like it to appear in our correspondance with you, and when citizens and employees interact with Mini City services."
                        }, null, 8, ["modelValue", "validator"]),
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.jobTitle,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((req.value.admin.jobTitle) = $event)),
                            onChange: _cache[3] || (_cache[3] = ($event) => (onChanged())),
                            validator: _unref(validator)(_unref(Validations).notEmpty),
                            label: "Job Title *",
                            description: "Please enter your job title (e.g. 'director', 'administrator')."
                        }, null, 8, ["modelValue", "validator"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.email,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((req.value.admin.email) = $event)),
                            onChange: _cache[5] || (_cache[5] = ($event) => (onChanged())),
                            validator: _unref(validator)(_unref(Validations).email),
                            label: "Email *",
                            description: "Please enter the email address of the administrator within your organization who will be overseeing your collaboration with Mini City. This email address will be used for account and billing-related correspondance."
                        }, null, 8, ["modelValue", "validator"]),
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.phone,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((req.value.admin.phone) = $event)),
                            onChange: _cache[7] || (_cache[7] = ($event) => (onChanged())),
                            validator: _unref(validator)(_unref(Validations).notEmpty),
                            label: "Phone *",
                            description: "Please enter your work phone number."
                        }, null, 8, ["modelValue", "validator"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.firstName,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((req.value.admin.firstName) = $event)),
                            validator: _unref(validator)(_unref(Validations).notEmpty),
                            label: "First Name *",
                            onChange: _cache[9] || (_cache[9] = ($event) => (onChanged())),
                            description: "Please enter your first name."
                        }, null, 8, ["modelValue", "validator"]),
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.middleName,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((req.value.admin.middleName) = $event)),
                            onChange: _cache[11] || (_cache[11] = ($event) => (onChanged())),
                            label: "Middle Name",
                            description: "Please enter your middle name"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.lastName,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((req.value.admin.lastName) = $event)),
                            onChange: _cache[13] || (_cache[13] = ($event) => (onChanged())),
                            validator: _unref(validator)(_unref(Validations).notEmpty),
                            label: "Last Name *",
                            description: "Please enter your last name."
                        }, null, 8, ["modelValue", "validator"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.address.number,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((req.value.admin.address.number) = $event)),
                            onChange: _cache[15] || (_cache[15] = ($event) => (onChanged())),
                            validator: _unref(validator)(_unref(Validations).notEmpty),
                            label: "Building Number / Name *",
                            description: "Enter the number or name of your organization's main office or HQ."
                        }, null, 8, ["modelValue", "validator"]),
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.address.street,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((req.value.admin.address.street) = $event)),
                            onChange: _cache[17] || (_cache[17] = ($event) => (onChanged())),
                            validator: _unref(validator)(_unref(Validations).notEmpty),
                            label: "Street *",
                            description: "Enter the street address of your organization's main office or HQ."
                        }, null, 8, ["modelValue", "validator"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.address.city,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((req.value.admin.address.city) = $event)),
                            onChange: _cache[19] || (_cache[19] = ($event) => (onChanged())),
                            validator: _unref(validator)(_unref(Validations).notEmpty),
                            label: "City *",
                            description: "Enter the city of your organization's main office or HQ."
                        }, null, 8, ["modelValue", "validator"]),
                        _createVNode(_component_FormTextField, {
                            modelValue: req.value.admin.address.postalCode,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((req.value.admin.address.postalCode) = $event)),
                            onChange: _cache[21] || (_cache[21] = ($event) => (onChanged())),
                            validator: _unref(validator)(_unref(Validations).notEmpty),
                            numeric: "",
                            length: 9,
                            label: "Zip / Postal Code *",
                            description: "Enter the zip / postal code of your organization's main office or HQ."
                        }, null, 8, ["modelValue", "validator"]),
                        _createVNode(_component_FormSelectField, {
                            modelValue: req.value.admin.address.state,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((req.value.admin.address.state) = $event)),
                            onChange: _cache[23] || (_cache[23] = ($event) => (onChanged())),
                            options: _unref(ProfileTypes).StateNotUnknown,
                            label: "State *",
                            description: "Select the state of your organization's main office or HQ."
                        }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(LocationListField, {
                            modelValue: req.value.siteNames,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((req.value.siteNames) = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_SaveButton, {
                        large: "",
                        label: "Next",
                        icon: "fa-chevron-right",
                        iconRight: "",
                        onClick: _cache[25] || (_cache[25] = ($event) => (onSubmitClicked()))
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
